import { render, staticRenderFns } from "./ModalDeposting.vue?vue&type=template&id=12ef2ba8"
import script from "./ModalDeposting.vue?vue&type=script&lang=js"
export * from "./ModalDeposting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports